import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import header from '@lepass/assets/images/coupon/header.jpg';
import { Col, Row } from 'antd';
import Loader from '@lepass/components/utility/loader';
import {
  getCanalPlusCouponPageContent,
  getGenericCouponPageContent,
  findCoupon,
  getBuyPassPageContent,
} from '@lepass/lib/helpers/coupon';

const PrefilledPromoCoupon = () => {
  const router = useRouter();
  const { coupon, lastname, firstname, email } = router.query;

  const [isLoading, setIsLoading] = useState(true);
  const [content, setContent] = useState(<></>);

  useEffect(() => {
    const defaultPageContent = async () => {
      const { campaignData = undefined } = await findCoupon(coupon);
      if (campaignData.price === 0) {
        setContent(
          await getBuyPassPageContent(coupon, lastname, firstname, email)
        );
      } else {
        setContent(
          await getGenericCouponPageContent(coupon, lastname, firstname, email)
        );
      }
    };

    const getContentPage = async () => {
      const prefix = coupon.split('-')[0];

      switch (prefix.toLowerCase()) {
        case 'ca':
          setContent(
            await getCanalPlusCouponPageContent(
              header,
              coupon,
              lastname,
              firstname,
              email
            )
          );
          break;
        default:
          await defaultPageContent();
          break;
      }
    };

    getContentPage().then(() => setIsLoading(false));
  }, []);

  return (
    <>
      <Head>
        <title>Promotion | Le PASS.nc</title>
      </Head>

      <div>
        <Row>
          <Col xs={0} md={9}></Col>
          <Col xs={24} md={6}>
            {isLoading ? (
              <div style={{ marginTop: 64 }}>
                <Loader />
              </div>
            ) : (
              <>
                {content}
                <div>
                  <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/BEmEc6TAJ5g?si=-z27GtbfWJPZh90_"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                </div>
              </>
            )}
          </Col>
          <Col xs={0} md={9}></Col>
        </Row>
      </div>
    </>
  );
};

export default PrefilledPromoCoupon;
